module.exports = __webpack_public_path__ + "static/img/第十三届.66dd979.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十三届.png
// module id = ulQO
// module chunks = 1